import { ApiResponseStatusEnum } from "@/model/communication/ApiResponseStatusEnum";
import { GetUpdatePackagesCommand } from "@/model/communication/updatePackages/GetUpdatePackagesCommand";
import { GetUpdatePackagesResData } from "@/model/communication/updatePackages/GetUpdatePackagesResData";
import { SET_UPDATE_PACKAGES_LIST, SET_UPDATE_PACKAGES_LIST_FETCHING } from "./mutations";

export const ON_UPDATE_PACKAGE_PAGE_LOAD = "ON_UPDATE_PACKAGE_PAGE_LOAD";
export const FETCH_UPDATE_PACKAGES_LIST = "FETCH_UPDATE_PACKAGES_LIST";

export default {
    async [ON_UPDATE_PACKAGE_PAGE_LOAD]({ commit }) {
        commit(SET_UPDATE_PACKAGES_LIST, []);
    },

    async [FETCH_UPDATE_PACKAGES_LIST]({ commit }) {
        commit(SET_UPDATE_PACKAGES_LIST_FETCHING, true);

        let res: GetUpdatePackagesResData = await new GetUpdatePackagesCommand().execute();

        if (res.responseStatus == ApiResponseStatusEnum.Success) {
            commit(SET_UPDATE_PACKAGES_LIST, res.updatePackagesList);
        }

        commit(SET_UPDATE_PACKAGES_LIST_FETCHING, false);
    },
};
